<template>
    <ui5-dialog
        ref="errorDialog"
        header-text="Nieuwe lakbon"
    >
        <div
            class="error-form"
            v-if="errorOptions"
        >
            <div>
                <div>Wat is de reden van de fout?</div>
                <ui5-select
                    @change="selectedError = $event.detail.selectedOption.value"
                >
                    <ui5-option
                        v-for="option in errorOptions"
                        :key="'error.' + option"
                        :selected="selectedError == option"
                        :value="option"
                    >
                        {{ option }}
                    </ui5-option>
                </ui5-select>
            </div>
        </div>

        <div
            slot="footer"
            class="dialog-footer"
        >
            <ui5-button
                :disabled="reporting"
                @click="$emit('create', selectedError)"
            >
                <div>
                    <spinner v-if="reporting" />
                    <span>Foutmelding aanmaken</span>
                </div>
            </ui5-button>
            <ui5-button
                :disabled="reporting"
                @click="close()"
            >
                Annuleren
            </ui5-button>
        </div>
    </ui5-dialog>
</template>

<script>
import errorReportErrorApi from '../../api/errorReportError';
import Spinner from '../loader/Spinner';

export default {
    name: 'ErrorReportDialog',
    components: { Spinner },
    props: {
        reporting: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            errorOptions: null,
            selectedError: null,
        };
    },
    mounted() {
        errorReportErrorApi.fetchAll().then((response) => {
            const errors = response.data.data;
            this.selectedError = errors[0];
            this.errorOptions = errors;
        });
    },
    methods: {
        show() {
            this.selectedError = this.errorOptions[0];
            this.$refs.errorDialog.show();
        },
        close() {
            this.$refs.errorDialog.close();
        },
    },
};
</script>
<style
    lang="scss"
    scoped
>
ui5-select {
    width: 100%;
}
ui5-button {
    > div {
        display: flex;
        align-items: center;
        gap: 8px;
    }
}
</style>
